import { ImportSource } from 'interfaces';
import { useMemo } from 'react';

import DropboxIconNew from 'assets/icons/integrations/dropbox-new';
import GoogleDriveIcon from 'assets/icons/integrations/google-drive';
import OneDriveIcon from 'assets/icons/integrations/one-drive';
import { ShareIcon } from 'assets/icons/library/MoreActionIcons';
import ScanSourceIcon from 'assets/icons/library/ScanSourceIcon';
import TextSourceIcon from 'assets/icons/library/TextSourceIcon';
import WebSourceIcon from 'assets/icons/library/WebSourceIcon';
import { useTranslation } from 'hooks/useTypedTranslation';
import { IntegrationService } from 'interfaces/integrations';

type ImportOptions<T> = {
  service: T;
  icon: React.ReactNode;
  title: string;
  showOnMobileOnly?: boolean;
}[];

export const useIntegrationImportOptions = () => {
  const { t } = useTranslation('common');

  const integrationImportOptions = useMemo<ImportOptions<IntegrationService>>(
    () => [
      {
        title: t('Google Drive')!,
        service: IntegrationService.GOOGLE_DRIVE,
        icon: <GoogleDriveIcon className="w-5 h-5 extraSmall:w-10 extraSmall:h-10" />
      },
      {
        title: t('Dropbox')!,
        service: IntegrationService.DROPBOX,
        icon: (
          <div className="flex items-center justify-center w-5 extraSmall:w-auto extraSmall:h-10">
            <DropboxIconNew />
          </div>
        )
      },
      {
        title: t('OneDrive')!,
        service: IntegrationService.ONE_DRIVE,
        icon: <OneDriveIcon className="w-5 h-5 extraSmall:w-10 extraSmall:h-10" />
      }
    ],
    [t]
  );

  const otherImportOptions = useMemo<ImportOptions<ImportSource>>(
    () => [
      {
        title: t('Upload from Files'),
        service: 'upload',
        icon: <ShareIcon className="text-icn-txt-prim w-5 h-5 extraSmall:w-10 extraSmall:h-10" />,
        showOnMobileOnly: true
      },
      {
        title: t('Add Text'),
        service: 'text',
        icon: <TextSourceIcon className="text-icn-txt-prim w-5 h-5 extraSmall:w-10 extraSmall:h-10" />
      },
      {
        title: t('Paste Web Link'),
        service: 'web',
        icon: <WebSourceIcon className="text-icn-txt-prim w-5 h-5 extraSmall:w-10 extraSmall:h-10" />
      },
      {
        title: t('Scan Pages'),
        service: 'scan',
        icon: <ScanSourceIcon className="text-icn-txt-prim w-5 h-5 extraSmall:w-10 extraSmall:h-10" />
      }
    ],
    [t]
  );

  return { integrationImportOptions, otherImportOptions };
};
